import clsx from "clsx";
import { FC } from "react";
import { useMoney } from "../../hooks/useMoney";
import { mergeClass } from "../../utils/common";

export const ProdPricing: FC<
  ProductBaseResponse & {
    className?: string;
    vari?: "WHITE" | "BLACK";
  }
> = ({ className, vari = "BLACK", ...product }) => {
  const { formatMoney } = useMoney();
  return (
    <div className={mergeClass("flex items-center", className)}>
      <span
        className={clsx(
          "font-semibold leading-[22px] sm:leading-[0.625rem]",
          vari === "WHITE" ? "text-sm text-white" : "text-sm text-[#232323]",
        )}
      >
        {formatMoney(product.price)}

        {product.displayPriceType === "FIXED" ? (
          <span> </span>
        ) : (
          <span> ~ </span>
        )}
        {product.originalPrice && product.price !== product.originalPrice && (
          <span
            className={clsx(
              "text-xs font-normal leading-[0.625rem] line-through",
              vari === "WHITE" ? "text-[#BFC5C9]" : "text-[#BFC5C9]",
            )}
          >
            {formatMoney(product.originalPrice)}
          </span>
        )}
      </span>
      {/* {!!product.duration && (
        <span className="ml-auto flex items-center gap-[0.3125rem]">
          <Icon className="size-[0.9375rem]" src={icClock} />
          <span className="flex items-center text-sm leading-[1.375rem] text-[#5E6D77]">
            {durationDisplay(product.duration)}
          </span>
        </span>
      )} */}
    </div>
  );
};
